import { m, useReducedMotion } from "motion/react";

export function ProgressIndicator({ current, total = 6 }: { current: number; total?: number }) {
  const percentage = Math.round((current / total) * 100);
  const reduceMotion = useReducedMotion();
  return (
    <div className="progress-block">
      <p className="progress-label" id="question-progress">Question {current} of {total}</p>
      <div className="progress-track" role="progressbar" aria-labelledby="question-progress" aria-valuemin={1} aria-valuemax={total} aria-valuenow={current}>
        <m.span
          className="progress-value"
          initial={false}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: reduceMotion ? 0 : 0.18, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>
    </div>
  );
}
